var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01716 8C6.76563 8 6.51414 7.90396 6.32238 7.71229L0.287903 1.67776C-0.0959678 1.29388 -0.0959678 0.671503 0.287903 0.287787C0.671619 -0.095929 1.29388 -0.095929 1.67778 0.287787L7.01716 5.62748L12.3566 0.287973C12.7404 -0.0957425 13.3626 -0.0957425 13.7463 0.287973C14.1304 0.67169 14.1304 1.29407 13.7463 1.67794L7.71194 7.71248C7.52008 7.90418 7.26859 8 7.01716 8Z",
    fill: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderDown);
export default __webpack_public_path__ + "static/media/calenderDown.ddc37cf22286dcb2d8792ace5040bcbf.svg";
export { ForwardRef as ReactComponent };